// Elemento Redes sociais — mesmas listas do servidor (LayoutCatalog).
export const SOCIAL_NETWORKS = [
  'instagram',
  'facebook',
  'whatsapp',
  'linkedin',
  'youtube',
  'tiktok',
  'x',
  'site',
];
export const ICON_STYLES = ['color', 'dark', 'light'];
export const SOCIAL_MAX = 8;

export const hasLink = url => !!url && url !== 'https://';

export const iconUrl = (style, network) =>
  `/email-icons/${ICON_STYLES.includes(style) ? style : 'color'}/${network}.png`;

// Preenche com as redes da conta sem apagar o que a pessoa digitou: rede que
// já tem link fica como está; as outras vêm da conta.
export const mergeSocialItems = (current, fetched) => {
  const typed = (current || []).filter(item => hasLink(item.url));
  const seen = new Set(typed.map(item => item.network));
  const extra = (fetched || []).filter(item => !seen.has(item.network));
  return [...typed, ...extra].slice(0, SOCIAL_MAX);
};
